export default function ErrorPage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-[#f5f5f5]">
      <div className="bg-white border border-red-200 rounded-xl p-8 max-w-md text-center shadow">
        <div className="text-4xl mb-4">⚠️</div>
        <h2 className="text-xl font-bold text-red-700 mb-2">Algo deu errado</h2>
        <p className="text-sm text-gray-600 mb-6">
          Ocorreu um erro inesperado. Nossa equipe já foi notificada.
          <br />
          Se o problema persistir, entre em contato com o suporte.
        </p>
        <div className="flex gap-3 justify-center">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-[#002233] text-white rounded-lg text-sm hover:bg-[#003355]"
          >
            Recarregar página
          </button>
          <button
            type="button"
            onClick={() => { window.location.href = '/'; }}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm hover:bg-gray-200"
          >
            Voltar para o início
          </button>
        </div>
      </div>
    </div>
  );
}
